module.exports = __webpack_public_path__ + "img/bulletHeck.f229429a.gif";